export default __webpack_public_path__ + "static/media/SearchAnggotaPoint.747d1c16.png";